import { render } from "./view_template_form.vue?vue&type=template&id=65f17185"
import script from "./view_template_form.js?vue&type=script&lang=js"
export * from "./view_template_form.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__